import { Navigate, Route, Routes } from "react-router-dom";
import ForexShell, { Blocked } from "./ForexShell";
import { useCan } from "./api";
import Overview from "./Overview";
import Accounts from "./Accounts";
import AccountDetail from "./AccountDetail";
import LiveBook from "./LiveBook";
import Reports from "./Reports";
import MtTransfers from "./MtTransfers";
import Users from "./Users";
import UserDetail from "./UserDetail";
import Masters from "./Masters";
import MasterDetail from "./MasterDetail";
import Connections from "./Connections";
import ConnectionDetail from "./ConnectionDetail";
import Settlements from "./Settlements";
import CopyEngine from "./CopyEngine";
import Roles from "./Roles";
import Operators from "./Operators";
import Audit from "./Audit";
import DeletedAccounts, { DeletedAccountDetail } from "./DeletedAccounts";
import Finance from "./Finance";
import RiskReports from "../forex/RiskReports";
import AccountHistory from "../forex/AccountHistory";
import Clients from "../forex/Clients";

// A page the operator's role does not open (025) shows this card and makes no
// call, rather than a 403 from every panel on it.
function Need({ perm, children }) {
  const can = useCan();
  if (can(perm)) return children;
  return (
    <Blocked title="Not allowed">
      Your forex role does not allow this page. Ask a forex manager for access.
    </Blocked>
  );
}

const need = (perm, element) => <Need perm={perm}>{element}</Need>;

export default function ForexAdmin() {
  return (
    <ForexShell>
      <Routes>
        <Route index element={<Overview />} />
        <Route path="accounts" element={need("accounts.read", <Accounts />)} />
        <Route path="accounts/:id" element={need("accounts.read", <AccountDetail />)} />
        <Route path="deleted-accounts" element={need("accounts.read", <DeletedAccounts />)} />
        <Route path="deleted-accounts/:login" element={need("accounts.read", <DeletedAccountDetail />)} />
        <Route path="book" element={need("accounts.read", <LiveBook />)} />
        <Route path="reports" element={need("reports.read", <Reports />)} />
        <Route path="finance" element={need("finance.read", <Finance />)} />
        {/* Risk Reports and Client Book still read the main backend's forex-risk routes. */}
        <Route path="risk" element={<RiskReports />} />
        <Route path="risk/account" element={<AccountHistory />} />
        <Route path="clients" element={<Clients />} />
        <Route path="transfers" element={need("transfers.read", <MtTransfers />)} />
        <Route path="users" element={need("users.read", <Users />)} />
        <Route path="users/:username" element={need("users.read", <UserDetail />)} />
        <Route path="masters" element={need("masters.read", <Masters />)} />
        <Route path="masters/:id" element={need("masters.read", <MasterDetail />)} />
        <Route path="connections" element={need("connections.read", <Connections />)} />
        <Route path="connections/:id" element={need("connections.read", <ConnectionDetail />)} />
        <Route path="settlements" element={need("settlements.read", <Settlements />)} />
        <Route path="copy-engine" element={need("copy_engine.read", <CopyEngine />)} />
        <Route path="roles" element={need(["roles.manage", "operators.manage"], <Roles />)} />
        <Route path="operators" element={need("operators.manage", <Operators />)} />
        <Route path="audit" element={need("audit.read", <Audit />)} />
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </ForexShell>
  );
}
